import { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SEO from './SEO';

export const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO page="impressum" />
      <Header />
      
      <main className="flex-1 pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Link */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#E31E24] hover:text-[#C41217] mb-8 font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>

          <h1 className="text-4xl font-bold text-neutral-900 mb-8">Impressum</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="text-neutral-700">
                <strong>FESCH Elektrotechnik GmbH</strong><br />
                An der Bergbahn 2a<br />
                42289 Wuppertal
              </p>
              <p className="text-neutral-700 mt-4">
                <strong>Vertreten durch den Geschäftsführer:</strong> Jonas Hellriegel
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Kontakt</h2>
              <p className="text-neutral-700">
                Telefon: 0202 / 430 445 10<br />
                E-Mail: info@fesch-elektrotechnik.de
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Registereintrag</h2>
              <p className="text-neutral-700">
                Eintragung im Handelsregister<br />
                Registergericht: Amtsgericht Wuppertal<br />
                Registernummer: HRB 33460
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Umsatzsteuer-ID</h2>
              <p className="text-neutral-700">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE361755678
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Aufsichtsbehörden</h2>
              <div className="text-neutral-700 space-y-4">
                <p>
                  <strong>Handwerkskammer Düsseldorf</strong><br />
                  Georg-Schulhoff-Platz 1<br />
                  40221 Düsseldorf<br />
                  Tel. 0211 8795-0<br />
                  Fax 0211 8795-110<br />
                  info@hwk-duesseldorf.de
                </p>
                <p>
                  <strong>IHK Wuppertal, Remscheid, Solingen</strong><br />
                  Heinrich-Kamp-Platz 2<br />
                  42103 Wuppertal (Elberfeld)<br />
                  Telefon: 0202 24 90 0<br />
                  Telefax: 0202 24 90 999<br />
                  E-Mail: ihk@bergische.ihk.de
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Streitschlichtung</h2>
              <p className="text-neutral-700">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#E31E24] hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-neutral-700 mt-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, 
                an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Haftung für Inhalte</h2>
              <p className="text-neutral-700">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach 
                den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter 
                jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen 
                oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Haftung für Links</h2>
              <p className="text-neutral-700">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-neutral-900 mb-4">Urheberrecht</h2>
              <p className="text-neutral-700">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
                deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen 
                Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Impressum;
